import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const myProfileSlice = createSlice({
  name: 'profile',
  initialState: {
    rcn: '',
    email: '',
    username: '',
    sponsorName: '',
    sponsorRcn: '',
    rank: '',
    status: '',
    daytimePhone: '',
    cellPhone: '',
    periodPgPv: '',
    lifetimePgPv: '',
    shipAddress: {
      id: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      formattedState: '',
      postalCode: '',
      country: '',
      isCommercial: false,
      geoCode: '',
      phone: '',
      formattedPhone: '',
      nameLine: '',
      type: '',
      data: {
        id: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        formattedState: '',
        postalCode: '',
        country: '',
        isCommercial: false,
        geoCode: '',
        phone: '',
        formattedPhone: '',
        nameLine: '',
      },
    },
    billAddress: {
      id: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      formattedState: '',
      postalCode: '',
      country: '',
      isCommercial: false,
      geoCode: '',
      phone: '',
      formattedPhone: '',
      nameLine: '',
      type: '',
      data: {
        id: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        formattedState: '',
        postalCode: '',
        country: '',
        isCommercial: false,
        geoCode: '',
        phone: '',
        formattedPhone: '',
        nameLine: '',
      },
    },
    primaryFirstName: '',
    primaryLastName: '',
    primaryDateOfBirth: '',
    primaryDateOfBirthString: '',
    isCustomer: false,
    isPreferredCustomer: false,
    isDistributor: false,
    isAmbassador: false,
    isEmployee: false,
    secondaryFirstName: '',
    secondaryLastName: '',
    secondaryDateOfBirth: '',
    secondaryDateOfBirthString: '',
    pvPeriod: '',
    canOrder: false,
  },
  reducers: {
    updateEmail: (state, action) => {
      return {
        ...state,
        email: action.payload,
      };
    },
    updateUsername: (state, action) => {
      return {
        ...state,
        username: action.payload,
      };
    },
    updateDaytimePhone: (state, action) => {
      return {
        ...state,
        daytimePhone: action.payload,
      };
    },
    updateCellPhone: (state, action) => {
      return {
        ...state,
        cellPhone: action.payload,
      };
    },
    updateShippingPostalCode: (state, action) => {
      return {
        ...state,
        shipAddress: {
          ...state.shipAddress,
          postalCode: action.payload,
        },
      };
    },
    updateShippingName: (state, action) => {
      return {
        ...state,
        shipAddress: {
          ...state.shipAddress,
          nameLine: action.payload,
        },
      };
    },
    updateShippingAddress1: (state, action) => {
      return {
        ...state,
        shipAddress: {
          ...state.shipAddress,
          addressLine1: action.payload,
        },
      };
    },
    updateShippingAddress2: (state, action) => {
      return {
        ...state,
        shipAddress: {
          ...state.shipAddress,
          addressLine2: action.payload,
        },
      };
    },
    updateShippingPhone: (state, action) => {
      return {
        ...state,
        shipAddress: {
          ...state.shipAddress,
          phone: action.payload,
        },
      };
    },
    updateShippingCity: (state, action) => {
      return {
        ...state,
        shipAddress: {
          ...state.shipAddress,
          city: action.payload,
        },
      };
    },
    updateShippingState: (state, action) => {
      return {
        ...state,
        shipAddress: {
          ...state.shipAddress,
          state: action.payload,
        },
      };
    },
    updateShippingCountry: (state, action) => {
      return {
        ...state,
        shipAddress: {
          ...state.shipAddress,
          country: action.payload,
        },
      };
    },
    updateBillingCountry: (state, action) => {
      return {
        ...state,
        billAddress: {
          ...state.billAddress,
          country: action.payload,
        },
      };
    },
    updateBillingPostalCode: (state, action) => {
      return {
        ...state,
        billAddress: {
          ...state.billAddress,
          postalCode: action.payload,
        },
      };
    },
    updateBillingAddress1: (state, action) => {
      return {
        ...state,
        billAddress: {
          ...state.billAddress,
          addressLine1: action.payload,
        },
      };
    },
    updateBillingAddress2: (state, action) => {
      return {
        ...state,
        billAddress: {
          ...state.billAddress,
          addressLine2: action.payload,
        },
      };
    },
    updateBillingCity: (state, action) => {
      return {
        ...state,
        billAddress: {
          ...state.billAddress,
          city: action.payload,
        },
      };
    },
    updateBillingState: (state, action) => {
      return {
        ...state,
        billAddress: {
          ...state.billAddress,
          state: action.payload,
          formattedState: action.payload,
        },
      };
    },
    updatePassword: (state, action) => {
      return {
        ...state,
        password: action.payload,
      };
    },
    updatePasswordTwo: (state, action) => {
      return {
        ...state,
        passwordTwo: action.payload,
      };
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchProfileData.fulfilled, (state, action) => {
      return action.payload;
    });
  },
});

export const fetchProfileData = createAsyncThunk('profile/fetchProfileData', async () => {
  const response = await axios.get('/api/checkout/profile/current');
  return response.data.data;
});

export const getZipCode = (state) => state.billAddress.postalCode;

export const getEmail = (state) => state.email;

export const {
  updateEmail,
  updateUsername,
  updateDaytimePhone,
  updateCellPhone,
  updateShippingPostalCode,
  updateShippingCity,
  updateShippingName,
  updateShippingAddress1,
  updateShippingAddress2,
  updateShippingPhone,
  updateShippingState,
  updateShippingCountry,
  updateBillingCountry,
  updateBillingCity,
  updateBillingState,
  updateBillingAddress1,
  updateBillingAddress2,
  updateBillingPostalCode,
  updatePassword,
  updatePasswordTwo,
} = myProfileSlice.actions;

export default myProfileSlice.reducer;
